import { render, staticRenderFns } from "./clients-by-branch.vue?vue&type=template&id=19a351c2"
import script from "./clients-by-branch.vue?vue&type=script&lang=js"
export * from "./clients-by-branch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports